(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check-and-info/assets/javascripts/third-party-cookies-settings.js') >= 0) return;  svs.modules.push('/components/components/cookies-check-and-info/assets/javascripts/third-party-cookies-settings.js'); 
(function(svs) {
  'use strict';

  var corporateName = svs.core.detect.tenant('tb')
      ? 'AB Svenska Spel'
      : 'Svenska Spel Sport & Casino AB';

  svs.components.cookies_check_and_info.thirdPartyCookiesSettings = (function() {
    function setEvents(el) {
      el.on(
        'click',
        '.js-third-party-cookies-continue',
        svs.components.cookies_check_and_info.thirdPartyCookiesSettings
          .onThirdPartyCookiesContinue
      );
      el.on(
        'click',
        '.js-third-party-cookies-back',
        svs.components.cookies_check_and_info.thirdPartyCookiesSettings
          .onThirdPartyCookiesBack
      );
    }

    function removeEvents(el) {
      el.off(
        'click',
        '.js-third-party-cookies-continue',
        svs.components.cookies_check_and_info.thirdPartyCookiesSettings
          .onThirdPartyCookiesContinue
      );
      el.off(
        'click',
        '.js-third-party-cookies-back',
        svs.components.cookies_check_and_info.thirdPartyCookiesSettings
          .onThirdPartyCookiesBack
      );
    }

    return {
      show: function() {
        var template,
          templateData = { corporateName },
          overlayStyle = svs.core.detect.formfactor.mobile() ? 'auto' : '420px';

        if (
          svs.components.cookies_check_and_info.dataHandler.getThirdPartyCookieAccepted()
        ) {
          templateData.viewData = {
            thirdPartyCookiesAccepted: true
          };
        } else {
          templateData.viewData = {
            thirdPartyCookiesAccepted: false
          };
        }

        template = svs.components.cookies_check_and_info.templates.third_party_cookies_settings(
          templateData
        );
        svs.components.overlay.show(template, true, {
          overlayStyle: overlayStyle,
          overflow: 'auto',
          className: 'cookie-info-box-overlay'
        });
        setEvents(svs.components.overlay.contentEl());
      },
      onThirdPartyCookiesContinue: function() {
        svs.components.cookies_check_and_info.thirdPartyCookiesSettings.saveThirdPartyCookiesAnswer(
          true
        );
        removeEvents(svs.components.overlay.contentEl());
        svs.components.overlay.hide();
      },
      onThirdPartyCookiesBack: function() {
        svs.components.cookies_check_and_info.thirdPartyCookiesSettings.saveThirdPartyCookiesAnswer(
          false
        );
        removeEvents(svs.components.overlay.contentEl());
        svs.components.overlay.hide();
        svs.components.cookies_check_and_info.cookieInfo.show(true);
      },
      saveThirdPartyCookiesAnswer: function(saveAndContinue) {
        var elements = $('.js-accept-third-party-cookies');
        if (elements.length) {
          if (saveAndContinue) {
            svs.components.cookies_check_and_info.dataHandler.setShowCookieInfo(
              false
            );
          }

          if (elements[0].checked) {
            svs.components.cookies_check_and_info.dataHandler.setThirdPartyCookieAccepted(
              true
            );
          } else {
            svs.components.cookies_check_and_info.dataHandler.setThirdPartyCookieAccepted(
              false
            );
          }
        }
      }
    };
  })();
})(svs);

 })(window);